import axios from 'axios';
// import { decodeToken } from '../../components/utils/decodeToken/decodeToken';

const apiUrl = process.env.REACT_APP_API_URL;

export const login = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}/auth/login`, body);

        if(response.status === 200) {
            // const token = decodeToken(response.data.jwt);

            // localStorage.setItem('user-jwt', response.data.jwt);
            // localStorage.setItem('authorities', JSON.stringify(response.data.authorities));
            
            return response.data;
        }

        throw new Error(response.data.message || 'Error desconocido');
    } catch (error) {
        console.error('Error al iniciar sesión: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const logout = async () => {
    try {
        /* 
            Ese null es porque no se envía el params, solo se necesita enviar el headers,
            se debe quitar más adelante, ya que debe tener un body que tenga accessToken
            y el refreshToken
        */
        const response = await axios.post(`${apiUrl}/auth/logout`, null, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(error);
        localStorage.clear();
        /* if (error.response.status === 401) {
            localStorage.removeItem('user-jwt');
            localStorage.removeItem('actual-sensor');
            // navigate('/');
        } else {
            // navigate('/error');
        } */

        throw error; // Propaga el error para manejarlo en el componente
    }
};